module.exports = __webpack_public_path__ + "static/img/industry_icon2.d695832.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/industry_icon2.png
// module id = 7qsR
// module chunks = 0